export default function ShrtContainer({
  children,
}: {
  children: React.ReactNode;
}) {
  return <div className="mx-0 px-0 py-10">{children}</div>;
}
